<template>
  
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data: function () {
    return {
    }
  },
  created () {
    
  },
  mounted () {
    if (!this.location.ready) {
      this.getLocation()
    }
    this.getStations()
    
  },
  methods: {
    ...mapActions([
      'getLocation', 'getStations'
    ])
  },
  computed: {
    ...mapGetters({
      location: 'location',
      stations: 'stations'
    })
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// App.vue?db30c9e4